import React, { useRef, useEffect } from "react"
import PropTypes from "prop-types"
import { Grid, Row, Col } from "react-flexbox-grid"
import { gsap } from "gsap"
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import Markdown from "../Markdown"

import "./About.scss"

const About = ({ title, list }) => {
  const refAbout = useRef()
  const refList = useRef([])

  useEffect(() => {
    if (refAbout) {
      gsap.registerPlugin(ScrollTrigger);

      if (refList) {
        const distance = [60, 80, 120]

        refList.current.map((x, i) => (
          gsap.from(x, {
            opacity: 0,
            y: distance[i],
            scrollTrigger: {
              trigger: refAbout.current,
              start: "top 100%",
              end: "+=50%",
              scrub: true,
              once: true,
              // markers: true
            }
          })
        ))
      }
    }
  }, [])

  return (
    <section ref={refAbout} className={`about`}>
      <Grid>
        {title ? 
          <Row>
            <Col sm={12} md={12}>
              <Markdown className="about__title | title">{title}</Markdown>
            </Col>
          </Row>
        : null }
        {list ? 
          <Row>
            {list.map((x, i) => 
              <Col sm={12} md={12} xl={3} xlOffset={i === 0 ? 0 : 1} key={i}>
                <div className="about__inner" ref={(ref) => refList.current.push(ref)}>
                  <Markdown className="about__subtitle">{x.title}</Markdown>
                  <Markdown className="about__text">{x.text}</Markdown>
                </div>
              </Col>
            )}
          </Row>
        : null }
      </Grid>
    </section>
  )
}

About.propTypes = {
  title: PropTypes.string.isRequired,
  list:  PropTypes.arrayOf(
    PropTypes.shape({ 
      title: PropTypes.string.isRequired, 
      text: PropTypes.string.isRequired 
    })
  ).isRequired,
}

About.defaultProps = {
  title: '',
  list: [
    {
      title: '',
      text: ''
    }
  ]
}

export default About